/* External dependencies */
import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';

/* Internal dependencies */
import Colors from '../colors';
import { ApplicationState } from '../store';
import { CurrentUserState, getCurrentUser } from '../store/ducks/currentUser';
import Icon, { Icons } from '../icon/Icon';
import ProfileDefaultAvatar from './ProfileDefaultAvatar';
import FollowUserButton from '../user/FollowUserButton';
import FollowArtistButton from '../artist/FollowArtistButton';
import FollowVenueButton from '../venues/FollowVenueButton';
import JoinCommunityButton from '../community/JoinCommunityButton';
import { ParticipantStatus } from '../types/Participant';
import { ProfileType } from '../types/Profile';
import { providerToProviderCode } from 'src/artist/ArtistDetail';
import User from 'src/types/User';

type OwnProps = {
  profile: ProfileType;
  isPreview?: boolean;
  imageSize?: number;
  style?: any;
  onClick?: () => void;
  disabled?: boolean;
  showAdd?: boolean;
};

type StateProps = {
  currentUser: CurrentUserState['user'];
};

type Props = OwnProps & StateProps;

type State = {
  storyOpen: boolean;
};

class ProfileImage extends React.Component<Props, State> {
  render() {
    const {
      profile,
      imageSize = 45,
      onClick: onClickFromProps, disabled = false, style = {},
      showAdd= false,
    } = this.props;
    if (!profile) return null;
    
    const profileId = get(profile, 'id');
    const profileType = get(profile, 'type')!;
    const profileImageUrl = get(profile, 'images[0].url');
    const profileProvider = get(profile, 'provider');
    const profileProviderId = get(profile, 'providerId');

    let detailUrl: string = `/users/${profileProviderId}`;

    if (profileType === 'community') {
      detailUrl = `/communities/${profileProviderId}`;
    } else if (profileType === 'artist') {
      detailUrl = `/artists/${providerToProviderCode[profileProvider]}/${profileProviderId}`;
    } else if (profileType === 'venue') {
      detailUrl = `/venues/${profileProviderId}`;
    }



    let content = (
      <Link
        className="d-flex justify-content-center align-items-center btn"
        to={disabled ? undefined as any : detailUrl}
        style={{
          borderRadius: Boolean(profileType === 'user' || profileType === 'artist') ? imageSize / 2 : 10,
          height: imageSize,
          width: imageSize,
          aspectRatio: '1',
          maxHeight: 'none',
          maxWidth: 'none',
          ...style,
        }}
      >
        {!Boolean(profileImageUrl) ? (
          <ProfileDefaultAvatar
            profile={profile}
            size={imageSize}
          />
        ) : (
          <Image
            src={profileImageUrl}
            style={{
              height: imageSize,
              width: imageSize,
              objectFit: 'cover',
              aspectRatio: '1',
              borderRadius: Boolean(profileType === 'user' || profileType === 'artist') ? imageSize / 2 : 5,
            }}
          />
        )}
      </Link>
    );
    
    return (
      <div style={{ position: 'relative' }}>
        {content}
        {Boolean(profileType === 'user' && showAdd) && (
          <div
            style={{
              position: 'absolute',
              bottom: 2,
              right: 8,
            }
          }>
            <FollowUserButton
              user={profile as User}
              // textSize="p"
              // paddingVertical={8}
              render={({ onClick, followedStatus }) => {

                if (Boolean(followedStatus === ParticipantStatus.confirmed)) return null;

                return (
                  <button
                    className="btn"
                    onClick={onClick as any}
                    style={{
                      backgroundColor: Colors.white,
                      width: imageSize * 0.5, aspectRatio: '1',
                      borderRadius: (imageSize * 0.5) / 2,
                      borderWidth: 2,
                      borderColor: Colors.background,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Icon
                      className="bm-Icon--dark"
                      name={Boolean(followedStatus === ParticipantStatus.pending) ? Icons.check : Icons.plus}
                      // color={Colors.background}
                      size={Boolean(followedStatus === ParticipantStatus.pending) ? (imageSize * 0.65) / 2 : (imageSize * 0.75) / 2}
                      solid={true}
                    />
                  </button>
                );
              }}
            />
          </div>
        )}
        {Boolean(profileType === 'community' && showAdd) && (
          <div style={{ position: 'absolute', bottom: -2, right: -8 }}>
            <JoinCommunityButton
              community={profile}
              // textSize="p"
              // paddingVertical={8}
              render={({ onClick, participantStatus }) => {

                if (Boolean(participantStatus === ParticipantStatus.confirmed)) return null;

                return (
                  <button
                    className="btn"
                    onClick={onClick as any}
                    style={{
                      backgroundColor: Colors.white,
                      width: imageSize * 0.5, aspectRatio: '1',
                      borderRadius: (imageSize * 0.5) / 2,
                      borderWidth: 2,
                      borderColor: Colors.background,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Icon
                      className="bm-Icon--dark"
                      name={Boolean(participantStatus === ParticipantStatus.pending) ? Icons.check : Icons.plus}
                      // color={Colors.background}
                      size={Boolean(participantStatus === ParticipantStatus.pending) ? (imageSize * 0.65) / 2 : (imageSize * 0.75) / 2}
                      solid={true}
                    />
                  </button>
                );
              }}
            />
          </div>
        )}
        {Boolean(profileType === 'artist' && showAdd) && (
          <div style={{ position: 'absolute', bottom: -2, right: -8 }}>
            <FollowArtistButton
              artist={profile}
              // textSize="p"
              // paddingVertical={8}
              render={({ onClick, followed }) => {

                if (Boolean(followed)) return null;

                return (
                  <button
                    className="btn"
                    onClick={onClick as any}
                    style={{
                      backgroundColor: Colors.white,
                      width: imageSize * 0.5, aspectRatio: '1',
                      borderRadius: (imageSize * 0.5) / 2,
                      borderWidth: 2,
                      borderColor: Colors.background,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Icon
                      name={Icons.plus}
                      className="bm-Icon--dark"
                      // color={Colors.background}
                      size={(imageSize * 0.75) / 2}
                      solid={true}
                    />
                  </button>
                );
              }}
            />
          </div>
        )}
        {Boolean(profileType === 'venue' && showAdd) && (
          <div style={{ position: 'absolute', bottom: -2, right: -8 }}>
            <FollowVenueButton
              venue={profile}
              // textSize="p"
              // paddingVertical={8}
              render={({ onClick, followed }) => {

                if (Boolean(followed)) return null;

                return (
                  <button
                    className="btn"
                    onClick={onClick as any}
                    style={{
                      backgroundColor: Colors.white,
                      width: imageSize * 0.5, aspectRatio: '1',
                      borderRadius: (imageSize * 0.5) / 2,
                      borderWidth: 2,
                      borderColor: Colors.background,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Icon
                      name={Icons.plus}
                      className="bm-Icon--dark"
                      // color={Colors.background}
                      size={(imageSize * 0.75) / 2}
                      solid={true}
                    />
                  </button>
                );
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  currentUser: getCurrentUser(state),
});

export default connect(mapStateToProps)(ProfileImage);